import React from "react";
import { Modal, Form, Input, Select, Space } from "antd";

export const BookingFilters = ({
  form,
  isModalOpen,
  handleCancel,
  setFilterForm,
  filterForm,
  handleFilter,
  bookingStatusList,
  bookingTypeList,
}) => {
  return (
    <Modal
      title="Filters"
      open={isModalOpen}
      onOk={handleFilter}
      okText="Filter Data"
      onCancel={handleCancel}
    >
      <Form form={form} layout="vertical">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="fromCity" className="subscription-plan">
            <Input
              value={filterForm?.fromCity}
              onChange={(e) =>
                setFilterForm({ ...filterForm, fromCity: e.target.value })
              }
              size="large"
              placeholder="Filter by From City"
            />
          </Form.Item>

          <Form.Item name="toCity" className="subscription-plan">
            <Input
              value={filterForm?.toCity}
              onChange={(e) =>
                setFilterForm({ ...filterForm, toCity: e.target.value })
              }
              size="large"
              placeholder="Filter by To City"
            />
          </Form.Item>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="bookingStatusId" className="subscription-plan">
            <Select
              value={filterForm?.bookingStatusId}
              onChange={(value) =>
                setFilterForm({ ...filterForm, bookingStatusId: value })
              }
              placeholder="Filter by Booking Status"
              style={{ width: "100%" }}
            >
              {bookingStatusList?.length > 0 ? (
                bookingStatusList.map((bookingStatus) => (
                  <Select.Option
                    key={bookingStatus.id}
                    value={bookingStatus.id}
                  >
                    {bookingStatus.statusName}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="default">Loading...</Select.Option>
              )}
            </Select>
          </Form.Item>

          <Form.Item name="bookingTypeId" className="subscription-plan">
            <Select
              value={filterForm?.bookingTypeId}
              onChange={(value) =>
                setFilterForm({ ...filterForm, bookingTypeId: value })
              }
              placeholder="Filter by Booking Type"
              style={{ width: "100%" }}
            >
              {bookingTypeList?.length > 0 ? (
                bookingTypeList.map((bookingType) => (
                  <Select.Option key={bookingType.id} value={bookingType.id}>
                    {bookingType.typeName}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="default">Loading...</Select.Option>
              )}
            </Select>
          </Form.Item>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="tripId" className="subscription-plan">
            <Input
              value={filterForm?.tripId}
              onChange={(e) =>
                setFilterForm({ ...filterForm, tripId: e.target.value })
              }
              size="large"
              placeholder="Filter by Trip Id"
            />
          </Form.Item>

          <Form.Item name="passengerPhone" className="subscription-plan">
            <Input
              value={filterForm?.passengerPhone}
              onChange={(e) =>
                setFilterForm({ ...filterForm, passengerPhone: e.target.value })
              }
              size="large"
              placeholder="Filter by Passenger Phone"
            />
          </Form.Item>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "20px",
          }}
        >
          <Form.Item name="isActive" className="subscription-plan">
            <Select
              value={filterForm?.isActive}
              onChange={(value) =>
                setFilterForm({ ...filterForm, isActive: value })
              }
              placeholder="Filter by Status"
              style={{ width: "100%" }}
              options={[
                { value: "false", label: "Inactive" },
                { value: "true", label: "Active" },
              ]}
            />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
};
